<section tuiContent>
	@if (form) {
		<form
			class="create-organization-dialog__form"
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
		>
			<label class="mt-6" tuiLabel>
				{{ 'data.name' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="name"
						tuiInput
						autocomplete="organization"
					/>
				</tui-textfield>

				<tui-error formControlName="name" [order]="['required']" />
			</label>

			<div class="form-divider mt-6"></div>

			<h3 class="mt-6">
				{{ 'admin.organizations.owner-details' | transloco }}
			</h3>
			<p class="text-sm text-gray-500 mb-4">
				{{ 'admin.organizations.multiple-owners-message' | transloco }}
			</p>

			<label tuiLabel>
				{{ 'data.email' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="ownerEmail"
						tuiInput
						autocomplete="email"
					/>
				</tui-textfield>

				<tui-error
					formControlName="ownerEmail"
					[order]="['required', 'email']"
				/>
			</label>

			<label tuiLabel>
				{{ 'data.given-name' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="ownerGivenName"
						tuiInput
						type="text"
						autocomplete="given-name"
					/>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.family-name' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="ownerFamilyName"
						tuiInput
						type="text"
						autocomplete="family-name"
					/>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.message' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<textarea
						tuiTextarea
						formControlName="ownerMessage"
					></textarea>
				</tui-textfield>
			</label>
		</form>
	}

	<div class="flex justify-end gap-2 mt-6">
		<button
			tuiButton
			size="s"
			type="button"
			appearance="ghost"
			[disabled]="busy()"
			(click)="onCancel()"
		>
			{{ 'action.cancel' | transloco }}
		</button>

		<button
			tuiButton
			size="s"
			type="submit"
			appearance="accent"
			[disabled]="!form || form.invalid || busy()"
			[loading]="busy()"
			(click)="onSubmit()"
		>
			{{ 'action.create' | transloco }}
		</button>
	</div>
</section>
